import { Directive, HostBinding } from '@angular/core';
import { NgModel } from '@angular/forms';
import { listDescriptionStyles } from '@kite_aerolab/shared/components';

@Directive({
  selector: '[listDescription]',
  providers: [NgModel],
})
export class ListDescriptionDirective {

  @HostBinding('class')
  public get setClasses() {
    return listDescriptionStyles({
    }).className;
  }
}
